// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"4edbbe7a","453":"80ee31f2"}[chunkId] + ".chunk.js";
};